var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgexport3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 226,
    height: 206,
    viewBox: "0 0 226 206",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.059 17.0781H84.8359V52.2586H142.059V17.0781Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.648 15.2012H83.4258V50.3816H140.648V15.2012Z",
    fill: "#FCA872",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4258 50.376L112.507 24.1104L140.648 50.376H83.4258Z",
    fill: "#FCA872",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4258 15.2012L112.039 38.1838L140.648 15.2012H83.4258Z",
    fill: "#FCA872",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.618 1H81.3285C71.9349 1 64.3203 8.6146 64.3203 18.0082V47.161C64.3203 56.5546 71.9349 64.1692 81.3285 64.1692H137.038L134.963 78.008L146.859 64.1259C155.739 63.4713 162.609 56.0749 162.607 47.1709V18.0082C162.607 8.62182 155.004 1.01082 145.618 1Z",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.563 27.1988H130.608C125.666 27.1988 121.66 23.1927 121.66 18.2506C121.671 13.3167 125.674 9.32227 130.608 9.32227H151.563C156.505 9.32227 160.511 13.3284 160.511 18.2704C160.511 18.2704 160.511 18.274 160.511 18.2749C160.498 23.2071 156.496 27.1988 151.563 27.1988Z",
    fill: "#333333",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.584 11.0059H132.492L132.356 21.2669H130.7L130.584 11.0059ZM130.584 23.1748H132.492V25.5119H130.584V23.1748Z",
    fill: "#FF934F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.662 11.0059H138.57L138.434 21.2669H136.778L136.662 11.0059ZM136.662 23.1748H138.57V25.5119H136.662V23.1748Z",
    fill: "#FF934F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.736 11.0059H144.644L144.508 21.2669H142.853L142.736 11.0059ZM142.736 23.1748H144.644V25.5119H142.736V23.1748Z",
    fill: "#FF934F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.811 11.0059H150.718L150.582 21.2669H148.927L148.811 11.0059ZM148.811 23.1748H150.718V25.5119H148.811V23.1748Z",
    fill: "#FF934F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.1187 179.407L33.3983 159.812H46.4689L61.4105 150.535L73.0835 156.204L99.2347 174.763L123.983 182.498L142.189 172.701L153.399 176.309L171.142 161.874H190.751L199.622 155.688L214.1 166.516L207.562 173.732L223.902 184.045L221.569 205.181H12.3867L16.1187 179.407Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.155 95.7523L170.805 91.7285L168.331 76.5733L143.681 80.5972L146.155 95.7523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M190.378 110.201L165.725 114.224L167.066 122.441L164.99 120.676L155.035 132.368L174.057 148.559L184.012 136.868L174.086 128.421L192.849 125.357L190.378 110.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.477 141.322L64.127 137.298L61.653 122.143L37.0031 126.166L39.477 141.322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.0669 111.276L83.2344 108.879L79.3354 84.209L64.168 86.6061L68.0669 111.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.8046 115.93L57.8262 104.295L38.901 87.9948L28.8794 99.6303L47.8046 115.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.411 68.6229L193.113 57.6094L175.2 40.2028L164.498 51.2163L182.411 68.6229Z",
    fill: "black"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.313 71.0883C122.313 71.0883 118.218 66.5547 111.78 66.9938C105.343 67.4329 100.804 73.4263 97.3014 77.5208C93.7984 81.6153 95.6929 85.7143 95.9895 86.2968C96.2862 86.8793 86.4832 92.7347 86.0441 97.8499C85.605 102.966 87.6527 104.727 87.0657 106.478C86.4787 108.229 76.9778 114.963 78.1464 119.082C78.9209 121.643 80.2707 123.994 82.093 125.953C82.093 125.953 77.9985 130.487 78.5855 132.825C79.1725 135.163 83.835 139.983 92.7687 143.505C101.702 147.027 130.793 147.743 141.034 143.648C151.275 139.554 153.757 126.392 152.292 124.493C150.826 122.594 146.441 120.676 147.042 118.203C147.643 115.731 149.528 112.204 148.212 110.014C146.894 107.824 143.095 106.941 141.779 104.602C140.463 102.264 142.948 99.0428 141.049 96.1178C139.149 93.1928 136.076 89.0983 136.076 89.0983C136.076 89.0983 133.003 76.0845 129.496 72.5725C125.987 69.0596 122.313 71.0883 122.313 71.0883Z",
    fill: "#333333",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2159 144.393L76.2441 168.812L88.8233 168.229L92.6266 149.217L81.2159 144.393Z",
    fill: "#F7D1B9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6191 147.508L91.853 152.838L91.9721 150.29L80.8482 146.119L80.6191 147.508Z",
    fill: "#FABC96"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152.73 140.883L161.798 163.407L150.244 167.941L142.055 146.442L152.73 140.883Z",
    fill: "#F7D1B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.171 145.077L143.396 149.945L142.055 146.442L152.73 140.883L154.171 145.077Z",
    fill: "#FABC96"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.591 102.856L107.859 116.166C107.859 116.166 102.376 117.922 98.8643 118.504C95.3523 119.087 87.9694 120.847 86.3608 124.207C84.7523 127.567 78.1719 145.267 78.1719 145.267L93.3803 150.754L95.8662 163.109L93.5282 186.655C93.5282 186.655 142.958 187.242 142.958 186.655C142.958 186.068 138.401 161.076 138.401 161.076L140.157 150.253L156.244 142.503C156.244 142.503 145.859 122.174 142.495 120.126C139.131 118.078 131.963 117.788 129.481 116.91C127.916 116.34 126.438 115.553 125.091 114.572L122.023 103.161L109.591 102.856Z",
    fill: "#FF924E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6527 136.664L94.4336 136.645L94.2196 139.092L94.4387 139.111L94.6527 136.664Z",
    fill: "#FFFFFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2993 141.075L94.0801 141.056L93.2328 150.747L93.4519 150.766L94.2993 141.075Z",
    fill: "#FFFFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.674 149.928L137.854 136.485",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.481 116.896C127.916 116.326 126.438 115.539 125.091 114.558L122.022 103.148L109.591 102.856L107.859 116.166C107.859 116.166 101.755 118.242 98.0234 119.03C100.615 120.733 108.045 125.014 117.217 124.781C125.12 124.58 130.775 120.237 133.505 117.584C132.146 117.468 130.801 117.238 129.481 116.896Z",
    fill: "#F7D1B9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M123.892 110.112L123.239 107.668L116.638 103.024H115.589L108.784 108.98L108.617 110.264C110.292 111.758 114.821 115.661 116.548 115.861C118.133 116.025 121.993 112.145 123.892 110.112Z",
    fill: "#FABC96"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.473 79.9501C121.473 79.9501 120.07 75.3209 117.145 76.6572C114.22 77.9935 111.418 83.1186 109.137 84.8651C106.856 86.6117 102.934 85.9534 102.934 85.9534C102.934 85.9534 103.387 98.786 104.805 103.018C106.222 107.252 112.173 112.687 114.773 113.04C117.374 113.392 120.309 111.799 122.365 109.255C124.422 106.712 126.183 105.09 126.66 102.23C127.104 99.6534 127.262 89.0453 127.17 87.9948C127.079 86.9453 123.401 83.7002 122.398 82.0726C121.396 80.4469 121.473 79.9501 121.473 79.9501Z",
    fill: "#F7D1B9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.158 96.7822L110.463 97.1113",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.332 97.4404L122.799 97.1113",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.535 100.709C113.535 100.709 114.809 101.664 116.126 101.325C116.904 101.126 117.603 100.695 118.13 100.089",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M116.652 105.001C116.629 105.721 116.175 106.289 115.697 106.275C115.22 106.261 114.805 105.655 114.829 104.934C114.853 104.214 115.306 103.642 115.784 103.661C116.261 103.68 116.681 104.285 116.652 105.001Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.87 95.2214C110.841 95.9705 110.497 96.5673 110.102 96.5529C109.706 96.5384 109.405 95.9227 109.434 95.1736C109.462 94.4244 109.801 93.8276 110.197 93.8421C110.593 93.8574 110.894 94.4533 110.87 95.2214Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.774 95.5924C121.745 96.3416 121.402 96.9384 121.006 96.924C120.61 96.9095 120.309 96.2938 120.333 95.5447C120.357 94.7955 120.706 94.1987 121.102 94.2131C121.497 94.2276 121.797 94.8433 121.774 95.5924Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.352 93.3115C103.352 93.3115 101.887 90.381 101.486 94.2898C101.085 98.1985 103.915 99.4771 103.915 99.4771L103.352 93.3115Z",
    fill: "#F7D1B9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M127.245 94.1146C127.245 94.1146 128.676 91.1658 129.12 95.0693C129.563 98.9728 127.016 99.0485 127.016 99.0485L127.245 94.1146Z",
    fill: "#F7D1B9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M149.072 148.05L136.641 133.733C136.641 133.733 133.573 128.76 132.823 127.591C131.869 126.265 130.845 124.991 129.755 123.773C129.755 123.773 128.29 123.339 128.877 125.239C129.422 126.761 130.108 128.228 130.925 129.624L131.216 131.381L118.025 126.67C117.474 126.473 116.867 126.759 116.67 127.31C116.655 127.354 116.641 127.398 116.631 127.444V127.515C116.529 127.984 116.757 128.463 117.185 128.679L124.21 132.258L113.668 130.411C113.089 130.311 112.539 130.7 112.438 131.28C112.434 131.309 112.429 131.337 112.427 131.366C112.389 131.876 112.721 132.339 113.214 132.469L122.892 135.023L113.862 135.538C113.299 135.562 112.86 136.037 112.884 136.6C112.887 136.662 112.895 136.724 112.908 136.783C113.008 137.216 113.377 137.535 113.82 137.571L123.751 138.387L117.179 139.699C116.775 139.784 116.517 140.182 116.602 140.586C116.679 140.925 116.98 141.165 117.327 141.163H125.359L129.892 142.041L135.452 142.771C135.452 142.771 149.64 169.538 150.079 170.412C150.518 171.286 152.856 172.756 155.195 172.756C157.534 172.756 160.817 170.189 161.537 168.561C162.215 167.044 163.093 163.98 160.315 161.055C157.538 158.129 149.072 148.05 149.072 148.05Z",
    fill: "#F7D1B9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.594 135.324L111.846 155.367L122.961 154.632L120.56 134.445L109.594 135.324Z",
    fill: "#333333",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.18 157.698L105.201 147.753C105.201 147.753 104.18 142.942 104.619 142.942C105.058 142.942 110.174 141.921 110.174 141.921L110.613 143.672L107.545 145.281L109.296 148.94L118.448 143.366C118.875 143.109 119.429 143.247 119.686 143.674C119.719 143.727 119.745 143.784 119.766 143.843C119.89 144.192 119.79 144.581 119.512 144.826L112.66 150.854L121.579 147.752C122.149 147.552 122.772 147.851 122.972 148.421C122.987 148.466 123.001 148.512 123.011 148.559C123.115 149.05 122.874 149.549 122.424 149.771L113.39 154.219L120.243 153.694C120.84 153.766 121.264 154.309 121.191 154.905C121.18 155.004 121.153 155.101 121.116 155.193C121 155.466 120.78 155.68 120.505 155.789L119.522 157.259C119.341 157.537 119.067 157.742 118.75 157.836L116.989 158.361L108.275 161.64C108.275 161.64 85.7503 177.578 85.1678 178.017C84.5853 178.457 83.259 179.044 80.1951 178.457C77.1312 177.87 74.492 173.207 75.2224 169.976C75.6931 167.749 77.2214 165.893 79.3169 165.004C80.1807 164.718 104.18 157.698 104.18 157.698Z",
    fill: "#F7D1B9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M110.817 160.341L107.309 153.18L107.111 153.276L110.619 160.438L110.817 160.341Z",
    fill: "#FABC96"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M120.718 155.687L120.668 155.471L113.158 157.223L113.208 157.439L120.718 155.687Z",
    fill: "#FABC96"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M151.164 204.938L142.936 186.655H93.5063L86.4336 204.938H151.164Z",
    fill: "#969696"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M119.933 75.8477C119.933 75.8477 117.647 76.6114 116.731 80.4191C115.895 83.6435 113.309 86.1186 110.05 86.8138C107.612 87.2908 105.631 85.5965 105.631 85.5965C107.615 86.2746 109.808 85.8697 111.42 84.5271C114.163 82.2459 112.789 77.9801 114.76 76.4572",
    fill: "#333333"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.933 75.8477C119.933 75.8477 117.647 76.6114 116.731 80.4191C115.895 83.6435 113.309 86.1186 110.05 86.8138C107.612 87.2908 105.631 85.5965 105.631 85.5965C107.615 86.2746 109.808 85.8697 111.42 84.5271C114.163 82.2459 112.789 77.9801 114.76 76.4572",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6226 203.091L69.7324 189.509L61.3812 174.07L36.2714 187.653L44.6226 203.091Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6465 203.08L51.1701 184.654L69.758 189.498L44.6465 203.08Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.291 187.646L54.301 190.938L61.4025 174.06L36.291 187.646Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116.861 205.183L121.528 202.659L113.176 187.226L88.0703 200.807L90.4372 205.183H116.861Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M116.858 205.184L121.525 202.659L102.942 197.815L100.332 205.184H116.858Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0703 200.807L106.08 204.099L113.176 187.226L88.0703 200.807Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9048 205.183L79.8441 191.692L71.4928 176.254L46.3867 189.84L54.6902 205.183H54.9048Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9055 205.184L79.8448 191.693L61.2623 186.85L54.7676 205.184H54.9055Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3867 189.84L64.3967 193.133L71.4928 176.254L46.3867 189.84Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9365 161.446L38.543 169.481L43.4838 186.324L70.8774 178.288L65.9365 161.446Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8703 178.28L53.2607 169.791L43.4785 186.317L70.8703 178.28Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M65.927 161.438L55.4568 176.455L38.5352 169.473L65.927 161.438Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M94.585 176.522L67.1914 184.558L72.1323 201.4L99.5258 193.364L94.585 176.522Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5149 193.354L81.9062 184.865L72.123 201.391L99.5149 193.354Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5715 176.512L84.1013 191.534L67.1797 184.548L94.5715 176.512Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M85.203 75.9011L56.9414 71.335L54.134 88.7112L82.3956 93.2773L85.203 75.9011Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6628 93.4948L70.456 78.2295L54.4883 88.8999L82.6628 93.4948Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4898 76.1788L69.5555 85.1982L57.3145 71.583L85.4898 76.1788Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2784 114.611L32.1055 110.012L29.2779 127.334L57.4508 131.933L60.2784 114.611Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4586 131.935L45.2509 116.664L29.2832 127.334L57.4586 131.935Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2799 114.611L44.3456 123.631L32.1055 110.016L60.2799 114.611Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M178.476 33.6057L150.303 29.0068L147.475 46.3288L175.648 50.9277L178.476 33.6057Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M175.657 50.9293L163.45 35.6631L147.482 46.3334L175.657 50.9293Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M178.479 33.6111L162.545 42.626L150.305 29.0107L178.479 33.6111Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M208.315 167.147L180.143 162.548L177.315 179.87L205.488 184.469L208.315 167.147Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M205.496 184.483L193.288 169.211L177.32 179.882L205.496 184.483Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32 167.159L192.386 176.178L180.145 162.563L208.32 167.159Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M158.597 182.516L130.424 177.917L127.596 195.239L155.769 199.838L158.597 182.516Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M155.772 199.848L143.565 184.576L127.598 195.252L155.772 199.848Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M158.598 182.527L142.665 191.547L130.424 177.932L158.598 182.527Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M207.407 128.239L179.234 123.64L176.407 140.962L204.58 145.561L207.407 128.239Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M204.58 145.57L192.372 130.304L176.404 140.974L204.58 145.57Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M207.409 128.25L191.475 137.265L179.234 123.649L207.409 128.25Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M121.946 158.556L97.2676 172.906L106.091 188.08L130.77 173.729L121.946 158.556Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M130.761 173.72L111.634 169.688L106.084 188.074L130.761 173.72Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M121.937 158.551L115.36 175.639L97.2598 172.905L121.937 158.551Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M159.017 80.3169L154.561 108.513L171.897 111.253L176.353 83.0568L159.017 80.3169Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M176.357 83.0352L161.148 95.3186L171.9 111.234L176.357 83.0352Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M159.021 80.2959L168.121 96.1824L154.568 108.495L159.021 80.2959Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M156.213 154.985L151.646 183.247L169.023 186.055L173.589 157.793L156.213 154.985Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M174.606 158.146L159.396 170.429L170.148 186.344L174.606 158.146Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M157.271 155.406L166.367 171.293L152.814 183.6L157.271 155.406Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M205.239 84.6359L183.609 103.266L195.064 116.565L216.694 97.935L205.239 84.6359Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M216.689 97.9219L197.142 97.4639L195.057 116.552L216.689 97.9219Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M205.239 84.624L201.909 102.624L183.607 103.254L205.239 84.624Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4601 30.0041L28.9863 49.8984L41.2183 62.4867L61.6921 42.5923L49.4601 30.0041Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6873 42.5859L42.1499 43.3019L41.2148 62.4813L61.6873 42.5859Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4568 30.0029L47.2143 48.1707L28.9844 49.8983L49.4568 30.0029Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3632 205.183L44.307 191.692L35.9557 176.254L10.8496 189.84L19.1486 205.183H19.3632Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3639 205.184L44.3077 191.693L25.7252 186.85L19.2305 205.184H19.3639Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8496 189.84L28.8596 193.133L35.9557 176.254L10.8496 189.84Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6708 205.304L31.5112 191.336L3.06445 193.698L4.02834 205.304H32.6708Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4987 205.303L17.8905 196.929L10.0352 205.303H28.4987Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06445 193.698L18.235 203.944L31.5112 191.336L3.06445 193.698Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M144.596 205.184L146.09 195.153L117.852 190.958L115.734 205.184H144.596Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M137.674 205.184L131.547 197.486L119.975 205.184H137.674Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M117.855 190.958L130.288 204.396L146.093 195.153L117.855 190.958Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3012 189.341L49.8281 190.426L50.4951 172.886L21.9682 171.801L21.3012 189.341Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3184 189.338L36.3122 176.798L49.8418 190.422L21.3184 189.338Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9824 171.804L35.8122 183.806L50.5104 172.888L21.9824 171.804Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M38.331 187.217L65.7246 195.253L70.6655 178.41L43.2719 170.374L38.331 187.217Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3379 187.221L55.9466 178.731L65.7297 195.257L38.3379 187.221Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 170.38L53.7505 185.398L70.6731 178.416L43.2812 170.38Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7365 205.183L44.8749 197.084L33.2362 183.951L11.8711 202.883L13.9089 205.183H35.7365Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7361 205.185L44.8745 197.086L25.6762 196.59L24.7168 205.185H35.7361Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8711 202.883L30.1579 202L33.2362 183.951L11.8711 202.883Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5973 205.184L59.947 193.764L32.5507 185.728L27.6113 202.568L36.5352 205.184H56.5973Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7968 205.184L45.2209 194.079L27.6113 202.568L36.5352 205.184H51.7968Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5527 185.728L43.0229 200.746L59.9491 193.764L32.5527 185.728Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M106.628 205.183L107.106 192.631L78.5783 191.544L78.0625 205.183H106.628Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M101.498 205.185L92.912 196.543L82.5762 205.185H101.498Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5801 191.544L92.4099 203.545L107.108 192.631L78.5801 191.544Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M196.604 187.661L171.494 174.078L163.143 189.517L188.253 203.099L196.604 187.661Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M188.267 203.08L181.739 184.654L163.156 189.498L188.267 203.08Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M196.616 187.646L178.607 190.938L171.506 174.06L196.616 187.646Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M178.223 205.183L186.527 189.84L161.42 176.254L153.068 191.692L178.008 205.183H178.223Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M178.142 205.184L171.652 186.85L153.068 191.693L178.008 205.184H178.142Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M186.523 189.84L168.512 193.133L161.416 176.254L186.523 189.84Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M174.665 188.101L149.555 174.519L141.203 189.957L166.313 203.54L174.665 188.101Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M166.327 203.52L159.804 185.095L141.217 189.938L166.327 203.52Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M174.681 188.086L156.671 191.379L149.57 174.5L174.681 188.086Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M213.76 205.183L222.063 189.84L196.953 176.254L188.602 191.692L213.545 205.183H213.76Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M213.679 205.184L207.189 186.85L188.602 191.693L213.545 205.184H213.679Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M222.06 189.84L204.05 193.133L196.949 176.254L222.06 189.84Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M166.736 205.183L170.291 198.612L145.185 185.03L136.834 200.463L145.558 205.183H166.736Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M158.805 205.184L155.417 195.62L136.834 200.464L145.558 205.184H158.805Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M170.292 198.612L152.282 201.905L145.186 185.03L170.292 198.612Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M210.929 171.818L182.402 172.902L183.069 190.442L211.596 189.357L210.929 171.818Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M211.593 189.338L196.599 176.798L183.07 190.422L211.593 189.338Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M210.925 171.804L197.1 183.806L182.402 172.888L210.925 171.804Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M199.783 182.356L181.305 160.598L167.927 171.959L186.405 193.717L199.783 182.356Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M186.385 193.724L186.982 174.182L167.902 171.963L186.385 193.724Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M199.766 182.364L181.785 178.909L181.283 160.607L199.766 182.364Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M189.638 170.388L162.244 178.424L167.185 195.267L194.579 187.231L189.638 170.388Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M194.571 187.221L176.961 178.731L167.174 195.257L194.571 187.221Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M189.627 170.38L179.161 185.398L162.234 178.416L189.627 170.38Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M218.999 205.183L221.042 202.883L199.673 183.951L188.033 197.084L197.177 205.183H218.999Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M208.195 205.185L207.236 196.59L188.033 197.086L197.177 205.185H208.195Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M221.045 202.883L202.759 202L199.676 183.951L221.045 202.883Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M196.368 205.184L205.292 202.568L200.353 185.728L172.961 193.764L176.311 205.184H196.368Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M196.369 205.184L205.293 202.568L187.684 194.079L181.107 205.184H196.369Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M200.353 185.728L189.883 200.746L172.961 193.764L200.353 185.728Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M174.076 183.659L145.549 184.744L146.216 202.284L174.743 201.199L174.076 183.659Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M174.738 201.184L159.744 188.643L146.215 202.271L174.738 201.184Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M174.077 183.646L160.247 195.648L145.549 184.734L174.077 183.646Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M70.681 205.183L85.9192 196.94L77.5679 181.503L52.4609 195.089L57.9206 205.183H70.681Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M70.68 205.184L85.9183 196.941L67.3349 192.098L62.7012 205.184H70.68Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4609 195.089L70.4718 198.382L77.5679 181.503L52.4609 195.089Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1243 121.97L39.3887 140.477L50.7676 153.841L72.5032 135.334L61.1243 121.97Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4998 135.348L52.9579 134.775L50.7578 153.855L72.4998 135.348Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1194 121.986L57.684 139.967L39.3828 140.493L61.1194 121.986Z",
    fill: "#8B8ED1",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 205.18H226",
    stroke: "#263238",
    strokeWidth: "0.575862px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M113.166 91.3102C112.916 91.5482 111.527 90.4247 109.485 90.3427C107.443 90.2606 105.903 91.2191 105.693 90.9612C105.586 90.8503 105.846 90.4112 106.523 89.9622C107.432 89.3887 108.495 89.1092 109.568 89.1615C110.631 89.2048 111.653 89.5835 112.487 90.2435C113.088 90.7502 113.284 91.2065 113.166 91.3102Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M124.787 91.3102C124.537 91.5482 123.148 90.4247 121.106 90.3427C119.064 90.2606 117.524 91.2191 117.314 90.9612C117.207 90.8503 117.467 90.4112 118.144 89.9622C119.053 89.3887 120.116 89.1092 121.189 89.1615C122.252 89.2048 123.274 89.5835 124.108 90.2435C124.709 90.7502 124.905 91.2065 124.787 91.3102Z",
    fill: "#263238"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport3);
export default __webpack_public_path__ + "static/media/svgexport-3.bb91d7093e14f65de763aee1e2a6b8dc.svg";
export { ForwardRef as ReactComponent };